import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateNavigationItem, resetNavigation } from 'app/store/fuse/navigationSlice';
import { DEPLOYMENT_REGIONS } from 'app/constants';

import config from '../../../config.json';

import useToggleCanadaOrdersView from './useToggleCanadaOrdersView';

// The pages a free (lite) branch is sent to the lite upgrade page from, wherever they sit in the
// sidebar. Prescribing sits in Workflow but stays open to free branches, as in connect-v1.
const freeBranchLockedItems = [
  'overdue-orders',
  'dashboard',
  'patients-component',
  'patients-help',
  'orders',
  'managed-repeats',
];
const freeBranchHiddenMenuItems = ['pro', 'online-shop'];

const { deploymentRegion = DEPLOYMENT_REGIONS.UK } = config;

const useConfigureNavbar = () => {
  useConfigureNavbarCanada();
  useConfigureNavbarUK();
};

function useConfigureNavbarCanada() {
  useToggleCanadaOrdersView();
}

function useConfigureNavbarUK() {
  const { selectedPharmacy } = useSelector((state) => state.pharmacySelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (deploymentRegion !== DEPLOYMENT_REGIONS.UK) return;

    if (selectedPharmacy) {
      const isFreePharmacy = selectedPharmacy.status === 'free';

      if (isFreePharmacy) {
        dispatch(updateNavigationItem('workflow', { locked: true }));
        freeBranchLockedItems.forEach((navItemId) => {
          dispatch(updateNavigationItem(navItemId, { url: '/lite-upgrade' }));
        });

        freeBranchHiddenMenuItems.forEach((navItemId) => {
          dispatch(updateNavigationItem(navItemId, { display: false }));
        });

        dispatch(updateNavigationItem('announcements', { display: true }));
        return;
      }

      dispatch(resetNavigation());

      dispatch(
        updateNavigationItem('pro', {
          display: selectedPharmacy.chain?.feature_flags?.pro_activation_journey !== false,
        })
      );

      dispatch(
        updateNavigationItem('announcements', {
          display: selectedPharmacy.chain?.feature_flags?.what_is_new !== false,
        })
      );
      dispatch(
        updateNavigationItem('managed-repeats', {
          display: selectedPharmacy.chain?.feature_flags?.assisted_ordering !== false,
        })
      );
      dispatch(
        updateNavigationItem('sms-campaigns', {
          display: selectedPharmacy.chain?.feature_flags?.sms_campaigns !== false,
        })
      );
      dispatch(
        updateNavigationItem('super-links', {
          display: selectedPharmacy.chain?.feature_flags?.super_links !== false,
        })
      );
      dispatch(
        updateNavigationItem('pgd', {
          display: selectedPharmacy.chain?.feature_flags?.pgds !== false,
        })
      );
      dispatch(
        updateNavigationItem('marketing-material', {
          display: selectedPharmacy.chain?.feature_flags?.marketing_material !== false,
        })
      );
    }
    // eslint-disable-next-line
  }, [
    selectedPharmacy?._id,
    selectedPharmacy?.status,
    selectedPharmacy?.chain?.feature_flags?.pro_activation_journey,
    selectedPharmacy?.chain?.feature_flags?.what_is_new,
    selectedPharmacy?.chain?.feature_flags?.assisted_ordering,
    selectedPharmacy?.chain?.feature_flags?.sms_campaigns,
    selectedPharmacy?.chain?.feature_flags?.super_links,
    selectedPharmacy?.chain?.feature_flags?.pgds,
    selectedPharmacy?.chain?.feature_flags?.marketing_material,
    dispatch,
  ]);
}

export default useConfigureNavbar;
